<template>
  <page-header-wrapper>
    <div class="back-content">
      <a-tabs
        class="back-content-tabs"
        :default-active-key="selectedTab"
        :active-key="selectedTab"
        :animated="false"
        @change="tabChange"
      >
        <a-tab-pane
          v-for="tab in tabs"
          :key="tab.key"
          :tab="tab.title"
        >
          <component :is="tab.component" />
        </a-tab-pane>
      </a-tabs>
    </div>
  </page-header-wrapper>
</template>

<script>
import AllProducts from './allProducts/AllProducts.vue'
import Producttype from './productType/ProductType.vue'
import ProductLine from './productLine/productLine.vue'
import { hasPermissions } from '@/permissions/util'

const settingTabs = [
  {
    title: '产品类型',
    key: 'producttype',
    component: 'Producttype'
  },
  {
    title: '全部产品',
    key: 'allProducts',
    component: 'AllProducts'
  },
  {
    title: '产品线管理',
    key: 'productLine',
    component: 'ProductLine',
    apis: ['@productLine/Query_ProductLine']
  }
]

export default {
  components: {
    Producttype,
    AllProducts,
    ProductLine
  },
  data () {
    return {
      // tabs: settingTabs,
      selectedTab: ''
    }
  },
  computed: {
    tabs () {
      const tabs = []

      settingTabs.forEach((item) => {
        if (item.apis) {
          if (hasPermissions(this.$store.state.apis, item.apis)) {
            tabs.push(item)
          }
        } else {
          tabs.push(item)
        }
      })

      return tabs
    }
  },
  watch: {
    '$route.query.tab': {
      handler: function (val) {
        this.setSelectedTab()
      }
    }
  },
  created () {
    this.setSelectedTab()
  },
  methods: {
    setSelectedTab () {
      if (this.$route.query && this.$route.query.tab) {
        this.selectedTab = this.$route.query.tab
      } else {
        this.selectedTab = this.tabs[0].key
      }
    },
    tabChange (activeKey) {
      this.$router.push({
        name: 'product',
        query: {
          tab: activeKey
        }
      })
    }
  }
}
</script>
